<template>
    <div class="measurement-panel">
        <div class="wgbt-machine">
            <div class="wgbt-meter">
                <div>
                    <div>
                        <h3>
                            気温
                            <span>Temperature</span>
                        </h3>
                    </div>
                    <div>
                        <p class="value">
                            {{
                                Math.round(
                                    currentWeatherData.temperature * 10
                                ) / 10
                            }}
                        </p>
                        <p class="unit">℃</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>
                            湿度
                            <span>Humidity</span>
                        </h3>
                    </div>
                    <div>
                        <p class="value">
                            {{
                                Math.round(
                                    currentWeatherData.relativeHumidity * 10
                                ) / 10
                            }}
                        </p>
                        <p class="unit">％</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h3>
                            WBGT値
                            <span>Wet Bulb Globe Temperature</span>
                        </h3>
                    </div>
                    <div>
                        <p class="value">
                            {{ Math.round(currentWeatherData.wbgt) }}
                        </p>
                        <!-- <p class="unit">℃</p> -->
                    </div>
                </div>
                <div>
                    <p>
                        <img :src="meterImage" alt />
                    </p>
                </div>
            </div>
            <!-- ./wgbt-meter -->
            <div class="wgbt-comment">
                <div>
                    <h4>{{ currentWeatherData.wbgtWord }}</h4>
                    <p>熱中症レベル{{ currentWeatherData.wbgtIndex }}</p>
                </div>
                <div>
                    <h5>{{ currentWeatherData.wbgtTitle }}</h5>
                    <p>{{ currentWeatherData.wbgtDesc }}</p>
                </div>
            </div>
            <!-- ./wgbt-comment -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        meterImage: {
            type: String,
            required: true
        },
        currentWeatherData: {
            type: Object,
            required: true
        }
    }
};
</script>
